import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface FinalTokenDetails {
  updated?: { $date: string };
  created?: { $date: string };
  finaltoken_id: string;
  no_of_token: number;
  beneficiary_name: string;
  certificate_retirement_purpose: string;
  yield_period?: string[];
  [key: string]: any;
}

export interface FinalTokenDetailsResponse {
  data: FinalTokenDetails[];
}

export interface FinalTokenQueryParams {
  [key: string]: string | number | boolean;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryFinalTokenApi = createApi({
  reducerPath: "registryfinaltoken",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryFinalToken"],
  endpoints: (build) => ({
    getRegistryFinalTokenDetails: build.query<FinalTokenDetailsResponse, FinalTokenQueryParams>({
      query: (params) => {
        return {
          url: "rs/registry/final-token",
          params: params,
          method: "GET",
        };
      },
      providesTags: ["RegistryFinalToken"],
    }),
  }),
});

export const {
  useGetRegistryFinalTokenDetailsQuery,
} = registryFinalTokenApi;
